import {
  Button,
  chakra,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { CategoryGridHeaderRow, CategoryModalGridItemsSection } from "./index";

function CategoryModal({ modalData, formData, attributesOrder, isOpen, onClose, onSubmit, getEmptyRow, mapRow }) {
  const { t } = useTranslation("translation");
  const { editData, columnHeaders, modalHeaderItemsType } = modalData;
  const { handleSubmit } = formData;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <chakra.form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>
            {t(`organizationQuestionnaire.${editData ? "editItemModalHeader" : "addItemsModalHeader"}`,
              { type: modalHeaderItemsType })
            }
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody overflow="auto">
            <Grid
              templateColumns={`repeat(${attributesOrder.length * 2 + (editData ? 0 : 1)}, 1fr)`}
              minWidth="700"
              maxHeight="400"
              overflow="auto"
            >
              <CategoryGridHeaderRow
                columnHeaders={columnHeaders}
              />
              <CategoryModalGridItemsSection
                modalData={modalData}
                formData={formData}
                numberOfColumns={attributesOrder.length}
                getEmptyRow={getEmptyRow}
                mapRow={mapRow}
              />
            </Grid>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              {t("buttons.close")}
            </Button>
            <Button colorScheme="customScheme" type="submit">
              {t("buttons.save")}
            </Button>
          </ModalFooter>
        </chakra.form>
      </ModalContent>
    </Modal>
  );
}

export default CategoryModal;